import { GET_INTREST_BILL_ADJUSTMENTS, SET_INTREST_BILL_ADJUSTMENTS, INTREST_BILL_ADJUSTMENT_REQUEST, INTREST_BILL_ADJUSTMENT_REQUEST_FAILURE, RESET_INTREST_BILL_ADJUSTMENTS } from '../types';

const initialState = {
  intrestBillAdjustments: [],
  loading: false,
  error: null,
  page: 1,
  limit: 10,
  totalRecords: 0,
  totalPages: 0,
};

const intrestBillAdjustmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case INTREST_BILL_ADJUSTMENT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_INTREST_BILL_ADJUSTMENTS: {
      const { page, limit, totalRecords, totalPages, data } = action.payload;
      return {
        ...state,
        intrestBillAdjustments: page === 1 ? data : [...state.intrestBillAdjustments, ...data],
        page,
        limit,
        totalRecords,
        totalPages,
        loading: false,
        error: null
      }
    }
    case SET_INTREST_BILL_ADJUSTMENTS: {
      return {
        ...state,
        intrestBillAdjustments: action.payload,
      }
    }
    case RESET_INTREST_BILL_ADJUSTMENTS:
      return {
        ...state,
        intrestBillAdjustments: [],
        page: 1,
        limit: 10,
        totalRecords: 0,
        totalPages: 0,
        loading: false,
        error: null
      };  
    case INTREST_BILL_ADJUSTMENT_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default intrestBillAdjustmentReducer;